import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingUpdateStatusBetslip: false,
  loadingUpdateStakeOddsBetslip: false,
  loadingManualResultSgm: false,
  loadingManualResultBetslip: false,
  loadingPreviewManualResult: false,
  loadingVoidSelections: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_UPDATE_STATUS_BETSLIP: (s, data) =>
      (s.loadingUpdateStatusBetslip = data),
    LOAD_UPDATE_STAKE_ODDS_BETSLIP: (s, data) =>
      (s.loadingUpdateStakeOddsBetslip = data),
    LOAD_MANUAL_RESULT_SGM: (s, data) => (s.loadingManualResultSgm = data),
    LOAD_MANUAL_RESULT_BETSLIP: (s, data) =>
      (s.loadingManualResultBetslip = data),
    LOAD_PREVIEW_MANUAL_RESULT: (s, data) =>
      (s.loadingPreviewManualResult = data),
    LOAD_VOID_SELECTIONS: (s, data) => (s.loadingVoidSelections = data),
  },

  actions: {
    async udpateStatusBetslip({ commit }, payload) {
      commit("LOAD_UPDATE_STATUS_BETSLIP", true);
      try {
        const { id, status } = payload;
        const res = await this.$api.put(
          `/v1/portal/betslips/${id}/status`,
          {
            status,
          },
          {
            headers: {
              channel: "cms",
            },
          }
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_STATUS_BETSLIP", false);
      }
    },
    async udpateStakeOddsBetslip({ commit }, payload) {
      commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", true);
      try {
        const { id, ...rest } = payload;
        const res = await this.$api.put(`/v1/portal/betslips/${id}`, rest);
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", false);
      }
    },
    async udpateResultBetslip({ commit }, payload) {
      commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", true);
      try {
        const { id, ...rest } = payload;
        const res = await this.$api.put(
          `/v1/portal/betslips/${id}/results`,
          rest
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", false);
      }
    },
    async manualResultSgmBetslip({ commit }, payload) {
      commit("LOAD_MANUAL_RESULT_SGM", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-cast/manual-result",
          payload
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_MANUAL_RESULT_SGM", false);
      }
    },
    // mode: "" (single/multi) | "exotic" | "quaddie" | "simple"
    async manualResultBetslip({ commit }, payload) {
      commit("LOAD_MANUAL_RESULT_BETSLIP", true);
      try {
        const { id, mode, ...body } = payload;
        const res = await this.$api.put(
          `/v1/portal/betslips/${id}/manual-result${mode ? `/${mode}` : ""}`,
          body
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_MANUAL_RESULT_BETSLIP", false);
      }
    },
    // Read-only: same body as manualResultBetslip, returns the expected result and payout
    async previewManualResultBetslip({ commit }, payload) {
      commit("LOAD_PREVIEW_MANUAL_RESULT", true);
      try {
        const { id, mode, ...body } = payload;
        const res = await this.$api.post(
          `/v1/portal/betslips/${id}/manual-result${mode ? `/${mode}` : ""}/preview`,
          body
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_PREVIEW_MANUAL_RESULT", false);
      }
    },
    async voidSportSelections({ commit }, voidSelectionIds) {
      commit("LOAD_VOID_SELECTIONS", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-events/void-selections",
          { voidSelectionIds }
        );
        return res?.data?.data ?? true;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_VOID_SELECTIONS", false);
      }
    },
    async updateMigratedResultBetslip({ commit }, payload) {
      commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", true);
      try {
        const { id, ...rest } = payload;
        const res = await this.$api.put(
          `/v1/portal/betslips/${id}/migrated-result`,
          rest
        );
        return res?.data?.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_STAKE_ODDS_BETSLIP", false);
      }
    },
  },
};
